import { useEffect } from "react";
import { SITE } from "../config";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/", jsonLd = [] }) => {
    useEffect(() => {
        const url = SITE.domain + path;
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("property", "og:image", SITE.domain + "/assets/img/hero.webp");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);

        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);

        const scripts = jsonLd.map((data) => {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.text = JSON.stringify(data);
            document.head.appendChild(s);
            return s;
        });
        return () => scripts.forEach((s) => s.remove());
    }, [title, description, path, jsonLd]);

    return null;
};
